import { useEffect } from "react";

export const useDisableIconDrag = () => {
  useEffect(() => {
    const handleDragStart = (e) => {
      const target = e.target;

      if (!(target instanceof HTMLImageElement)) {
        return;
      }

      const src = target.src.toLowerCase();
      
      if (
        src.includes("/static/media/") &&
        src.endsWith(".svg")
      ) {
        e.preventDefault();
      }
    };

    document.addEventListener("dragstart", handleDragStart);

    return () => {
      document.removeEventListener("dragstart", handleDragStart);
    };
  }, []);
};